export default "__VITE_ASSET__d6c0d83d__"